import { ACCENT, LINE } from './theme.js';

export default function FontStyles() {
  return (
    <style>{`
      @import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,300..800;9..144,300..800&family=Geist:wght@300..700&family=Geist+Mono:wght@400..600&display=swap');

      .ff-display { font-family: 'Fraunces', Georgia, 'Times New Roman', serif; font-feature-settings: 'ss01'; font-optical-sizing: auto; }
      .ff-ui { font-family: 'Geist', -apple-system, BlinkMacSystemFont, system-ui, sans-serif; }
      .ff-mono { font-family: 'Geist Mono', ui-monospace, monospace; }

      .smallcaps { text-transform: uppercase; letter-spacing: 0.18em; font-size: 10px; font-weight: 500; }
      .widecaps { text-transform: uppercase; letter-spacing: 0.3em; font-weight: 500; }

      @keyframes screenIn { from { opacity: 0; transform: translateY(6px); } to { opacity: 1; transform: translateY(0); } }
      .screen-in { animation: screenIn 380ms cubic-bezier(0.2, 0.8, 0.2, 1); }

      @keyframes foxGlow {
        0%, 100% { opacity: 0.92; }
        50% { opacity: 1; filter: drop-shadow(0 0 8px rgba(166,124,58,0.25)); }
      }
      .fox-glow { animation: foxGlow 4s ease-in-out infinite; }

      .scrollbar-hide::-webkit-scrollbar { display: none; }
      .scrollbar-hide { scrollbar-width: none; }

      .grain::before {
        content: '';
        position: absolute; inset: 0;
        background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 240 240' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/%3E%3CfeColorMatrix values='0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.5 0'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.7'/%3E%3C/svg%3E");
        opacity: 0.06; mix-blend-mode: multiply; pointer-events: none;
      }

      .hairline { background: linear-gradient(to right, transparent, ${LINE} 20%, ${LINE} 80%, transparent); }
      .hairline-gold { background: linear-gradient(to right, transparent, ${ACCENT} 20%, ${ACCENT} 80%, transparent); opacity: 0.45; }
    `}</style>
  );
}
